import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { FundingClientDetailsView } from '../components/views/fundingClientDetailsView'
import { useParams, useNavigate } from 'react-router-dom'

function FundingClientDetails() {
    const { clientId } = useParams<{ clientId: string }>()
    const navigate = useNavigate()

    return (
        <div className="fundingClientDetails">
            <Sidebar />
            <MainView>
                <div
                    style={{
                        marginBottom: '16px',
                        paddingBottom: '12px',
                        borderBottom: '1px solid #e0e0e0',
                    }}
                >
                    <button
                        onClick={() => navigate(-1)}
                        style={{
                            background: 'transparent',
                            color: '#666',
                            border: 'none',
                            padding: '6px 0',
                            cursor: 'pointer',
                            fontSize: '13px',
                            fontWeight: '500',
                            transition: 'color 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            textDecoration: 'none',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.color = '#333'
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.color = '#666'
                        }}
                    >
                        <span style={{ fontSize: '16px', lineHeight: '1' }}>←</span>
                        <span>Back to Batch</span>
                    </button>
                </div>
                <FundingClientDetailsView />
            </MainView>
        </div>
    )
}

export default FundingClientDetails
